import { render, staticRenderFns } from "./singapore10Years.vue?vue&type=template&id=1ed7138d&scoped=true&"
import script from "./singapore10Years.vue?vue&type=script&lang=js&"
export * from "./singapore10Years.vue?vue&type=script&lang=js&"
import style0 from "./singapore10Years.vue?vue&type=style&index=0&id=1ed7138d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed7138d",
  null
  
)

export default component.exports